import { render } from "./OHouContent.vue?vue&type=template&id=1cc7102c&bindings={}"
import script from "./OHouContent.vue?vue&type=script&lang=ts"
export * from "./OHouContent.vue?vue&type=script&lang=ts"

import "./OHouContent.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script